import React, { useState } from "react";

export interface Testimonial {
  header: string;
  content: string;
  star: number;
  experience: string;
  isHTML?: boolean;
}

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Card */}
      <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-6 flex flex-col h-[420px]">
        <h3 className="text-lg font-semibold text-main mb-2">{testimonial.header}</h3>
        <div className="flex mb-2 text-accent">
          {"★".repeat(testimonial.star)}
          {"☆".repeat(5 - testimonial.star)}
        </div>

        {testimonial.isHTML ? (
          <div
            className="text-gray-700 text-sm [&>p]:m-0 [&>p]:mb-2 [&>p:last-child]:mb-0"
            dangerouslySetInnerHTML={{ __html: testimonial.content }}
          />
        ) : (
          <p className="text-gray-700 text-sm line-clamp-4">{testimonial.content}</p>
        )}

        <p className="text-sm text-hover italic mt-auto">{testimonial.experience}</p>

        <button
          onClick={() => setOpen(true)}
          className="text-sm text-main font-semibold mt-4 hover:underline"
        >
          Read more
        </button>
      </div>

      {/* Modal */}
      {open && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4">
          <div className="bg-white rounded-2xl max-w-xl w-full p-6 relative max-h-[80vh] overflow-y-auto">
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>

            <h3 className="text-xl font-bold text-main mb-2">{testimonial.header}</h3>
            <div className="flex mb-3 text-accent">
              {"★".repeat(testimonial.star)}
              {"☆".repeat(5 - testimonial.star)}
            </div>

            {testimonial.isHTML ? (
              <div
                className="text-gray-700 text-sm [&>p]:m-0 [&>p]:mb-2 [&>p:last-child]:mb-0"
                dangerouslySetInnerHTML={{ __html: testimonial.content }}
              />
            ) : (
              <p className="text-gray-700 text-sm whitespace-pre-line">{testimonial.content}</p>
            )}

            <p className="mt-4 text-sm text-hover italic">{testimonial.experience}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default TestimonialCard;
